<template>
    <div>
        <!-- The button to open modal -->
        <button
            :class="buttonClass"
            class="btn modal-button"
            @click.stop="openModal"
            :disabled="!!disabled"
        >
            {{ label }}
        </button>
        <div class="modal" :class="{ 'modal-open': open }" v-if="open" @click.stop="close">
            <div class="modal-box" @click.stop="">
                <h3 class="font-bold text-lg">{{ title }}</h3>
                <p class="py-4">
                    <slot></slot>
                </p>
                <div class="modal-action flex justify-between">
                    <button @click.stop="close" class="btn btn-error">{{ no }}</button>
                    <button @click.stop="ok" class="btn btn-success">
                        {{ yes }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    props: ['label', 'title', 'buttonClass', 'disabled', 'yes', 'no'],
    data() {
        return {
            open: false,
        };
    },
    methods: {
        ok(e) {
            this.$emit('submit');
            this.close();
        },
        close() {
            this.open = false;
        },
        openModal() {
            this.open = true;
        },
    },
};
</script>

<style scoped></style>
